import angular from 'angular';
import resource from './resource';

export default angular.module('akamai.components.resource', [
])
  .factory('Resource', resource);